const account = {
    _newAddress() {
      let editButton = document.querySelectorAll('.address-card__button.edit');
      if(editButton) {
        editButton.forEach(item => {
          item.addEventListener('click', event => {
            let editForm = '[data-address-id="'+event.target.getAttribute("data-edit-address")+'"]';
            document.querySelector(editForm).classList.remove('hidden');
            document.querySelector('.edit-address').classList.remove('hidden');
            document.querySelector('.save-addresses').classList.add('hidden');
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          })
        })
      }
      let editBackButton = document.querySelectorAll('.back-btn');
      if(editBackButton) {
        editBackButton.forEach(item => {
          item.addEventListener('click', event => {
            let editForm = '[data-address-id="'+event.target.getAttribute("data-edit-address")+'"]';
            let form = document.querySelector(editForm);
            document.querySelector(editForm).classList.add('hidden');
            document.querySelector('.edit-address').classList.add('hidden');
            document.querySelector('.add-new-address').classList.add('hidden');
            document.querySelector('.save-addresses').classList.remove('hidden');
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            this._clearForm(form)
          })
        })
      }
      let deleteButton = document.querySelectorAll('.address-card__button.delete');
      if(deleteButton) {
        deleteButton.forEach(item => {
          item.addEventListener('click', event => {
            event.target.closest('.btn--actions').classList.add('hidden');
            let deleteActions = ".delete--actions-"+event.target.getAttribute("data-delete-address");
            document.querySelectorAll(deleteActions)[0].classList.remove('hidden');
          })
        })
      }
      let deleteNoButton = document.querySelectorAll('.btn-no');
      if(deleteNoButton) {
        deleteNoButton.forEach(item => {
          item.addEventListener('click', event => {
            event.target.closest('.delete--actions').classList.add('hidden');
            let deleteActions = ".actions-"+event.target.getAttribute("data-address");
            document.querySelector(deleteActions).classList.remove('hidden');
          })
        })
      }
      let deleteYesButton = document.querySelectorAll('.btn-yes');
      if(deleteYesButton) {
        deleteYesButton.forEach(item => {
          item.addEventListener('click', event => {
            let formId = event.target.getAttribute("data-address"); 
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
          })
        })
      }
      let addButton = document.querySelectorAll('.add-address');
      if(addButton) {
        addButton.forEach(item => {
          item.addEventListener('click', event => {
            document.querySelector('.add-new-address').classList.remove('hidden');
            document.querySelector('.add-new-address .account-address-form').classList.remove('hidden');
            document.querySelector('.save-addresses').classList.add('hidden');
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          })
        })
      }
    },
    _state() {
      let form = document.querySelectorAll('.account-address-form');
      form.forEach(el => {
        let id = el.getAttribute('data-address-id'),
          countryEl = "customer_addr_".concat(id, "_country"),
          provinceEl = "customer_addr_".concat(id, "_province"),
          options = {
            hideElement: "address_province_container_".concat(id)
          }; // Initiate provinces for address forms
        new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
      });
    },
    _clearForm(form) {
      if (!form) return
      form.querySelectorAll('input:not([type=hidden])').forEach(input => {
        if (input.type == 'checkbox') {
          input.checked = (input.dataset.default == 'true' ? true : false)
        } else {
          input.value = input.dataset.default
        }
      })
      form.querySelectorAll('select').forEach(select => {
        select.value = select.dataset.default
      })
    },
    init() {
      this._newAddress();
      this._state();
    }
  }
  
  export default account